module.exports = __webpack_public_path__ + "static/media/Lacapsulerose.76b0b010.png";